import { createFileRoute } from "@tanstack/react-router";
import NewPassword from "@/auth/new-password";

export const Route = createFileRoute("/(auth)/new-password")({
  component: NewPassword,
});
